/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { useEditorUIContext } from "../contexts";

export function useEditorRootEl(): React.MutableRefObject<HTMLElement> {
	const editorUiCtx = useEditorUIContext();
	return editorUiCtx.rootEl;
}
